import script from "./IEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IEventItem.vue?vue&type=script&setup=true&lang=js"

import "./IEventItem.vue?vue&type=style&index=0&id=319ce047&lang=scss"

const __exports__ = script;

export default __exports__